import { SyntheticEvent } from 'react';

import { BaseEditor, Editor } from 'slate';
import { ReactEditor, useSlate } from 'slate-react';

import Icon from '../Icon';
import Button from './index';

function MarkButton({ format, icon }: any) {
  const editor = useSlate();

  const isMarkActive = (editor: BaseEditor & ReactEditor, format: string) => {
    const marks: any = Editor.marks(editor);
    return marks ? marks[format] === true : false;
  };

  const toggleMark = (editor: BaseEditor & ReactEditor, format: string) => {
    const isActive = isMarkActive(editor, format);

    if (isActive) {
      Editor.removeMark(editor, format);
    } else {
      Editor.addMark(editor, format, true);
    }
  };

  return (
    <Button
      active={isMarkActive(editor, format)}
      onMouseDown={(event: SyntheticEvent) => {
        event.preventDefault();
        toggleMark(editor, format);
      }}
    >
      <Icon>{icon}</Icon>
    </Button>
  );
}

export default MarkButton;
